import { validateUserActivity, logOut } from '../common/Components/UserManagement/controllers/actions';
import useInterval from './useInterval';
import { useAppDispatch } from 'store';
import * as constActions from 'common/Components/MasterSlave/controllers/const';
import { eLogoutReason } from 'common/Enums/Enums';
import { isNewBackend } from 'config';

function useUserActivity() {
  const VALIDATE_USER_ACTIVITY_INTERVAL_MS = 180000; // 3 min
  const dispatch = useAppDispatch();

  const log = (message: string) => {
    if (window.logUserSession) {
      // eslint-disable-next-line no-console
      console.log(`##### legacy validateUser() interval - ${message}`);
    }
  };

  async function validateUser() {
    if (isNewBackend) {
      log('skipping validateUser() - NewBackend mode');
      return;
    }
    try {
      log(`called.\ninterval time: ${VALIDATE_USER_ACTIVITY_INTERVAL_MS / 1000} seconds`);
      dispatch(validateUserActivity()).then((res: any) => {
        if (!res) {
          log('validateUserActivity result is false - logging out');
          dispatch({ type: constActions.RESET_STORE });
          logOut(eLogoutReason.ValidateUserActivityIntervalNoResponse);
        } else {
          log('validateUserActivity success');
        }
      });
    } catch (err) {
      log(`Failed to get response validateUserActivity: ${err}`);
      console.warn(`Failed to get response validateUserActivityInterval: ${err}`);
    }
  }

  useInterval(validateUser, VALIDATE_USER_ACTIVITY_INTERVAL_MS);
}

export default useUserActivity;
